import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {
  FullProblemTemplate
} from "../../../../admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component";
import {checkForHTMLTags} from "../../../utils/checkForHTMLTags";
import {NgClass} from "@angular/common";
interface Foo {
  [key: string]: string | undefined | null;
}
@Component({
    selector: 'multifield',
    styleUrls: ['../../../../admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.css'],
  imports: [FontAwesomeModule, FormsModule, MatCheckboxModule, NgClass],
    templateUrl: './multifield.component.html'
})
export class MultifieldComponent implements OnInit{
  @Input('review') review: boolean = false;
  @Input('problem_template') problem_template!: FullProblemTemplate
  @Input('answer') answer?: string = ''
  @Output() answerChange = new EventEmitter<string>()
  @Output() onChangeEmitter = new EventEmitter<Function>()
  radioStyle = `accent-color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem;`
  clusterJson:Foo = {
  }
  checkForHTMLTags = checkForHTMLTags

  ngOnInit() {
    for(let cluster of this.problem_template.clusters) {
      for(let field of cluster.fields) {
        this.clusterJson = {...this.clusterJson, [field.id]: field.recordedAnswer}
      }
    }
  }

  onChange() {
    // TODO need key value pairs and emit the json
    this.answerChange.emit(JSON.stringify(this.clusterJson))
    this.onChangeEmitter.emit(this.onChangeEmitter)
  }

  onTextChange(value: string | undefined, field_id: string) {
    this.clusterJson[field_id] = value
    this.onChange();
  }

  onCheckBoxSelection(value: string, field_id: string) {
    this.clusterJson[field_id] = value
    this.onChange()
  }

  onSelectChange(eventTarget: Event, field_id: string) {
    this.clusterJson[field_id] = (eventTarget.target as HTMLInputElement).value
    this.onChange()
  }
}
